var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCentrixLongWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1408px",
    height: "256px",
    viewBox: "0 0 1408 256",
    enableBackground: "new 0 0 1408 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M170.721,181.677c0,10.07-15.479,18.743-33.209,18.743s-33.139-13.009-33.139-23.081 c0-10.073,16.516-17.325,34.246-17.325C156.349,160.014,170.721,171.604,170.721,181.677z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M249.149,137.702c-5.426-11.415-32.492-9.231-45.771,0c-13.544,9.42-24.085,37.115-14.198,44.987 c10.975,8.74,32.297,3.555,45.788-5.94C252.912,164.118,254.609,149.19,249.149,137.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M193.529,217.553c0,7.589-9.25,17.473-22.808,17.473c-13.56,0-26.295-3.438-26.295-11.026 s10.992-18.498,24.552-18.498C182.537,205.501,193.529,209.964,193.529,217.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M305.622,150.207c0,10.539-11.147,27.91-23.655,27.91c-12.506,0-22.367-4.14-22.367-14.678 c0-10.541,10.868-25.191,23.375-25.191C295.483,138.248,305.622,139.668,305.622,150.207z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M269.96,95.576c0,13.523-11.695,22.493-23.677,22.493c-11.981,0-29.496-15.562-29.496-29.084 c0-13.524,7.343-24.187,19.323-24.187C248.092,64.797,269.96,82.052,269.96,95.576z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M82.259,187.163c0,6.264-4.192,10.882-9.419,10.882c-5.226,0-12.641-10.656-12.641-16.919 c0-6.265,3.66-12.073,8.886-12.073S82.259,180.899,82.259,187.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M51.446,115.618c0,5.364,0.261,9.066,4.183,9.066c3.922,0,9.927-5.462,9.927-10.829 c0-5.366,1.013-10.82-2.909-10.82C58.725,103.036,51.446,110.252,51.446,115.618z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M101.767,149.19c0,11.678-4.958,19-13.905,19c-8.947,0-20.834-12.74-20.834-24.421 c0-11.676,4.004-19.868,12.951-19.868S101.767,137.513,101.767,149.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M271.243,48.387c0,5.324-4.541,10.047-11.643,10.047s-20.242-8.077-20.242-13.401 c0-5.323,5.188-10.348,12.29-10.348C258.75,34.686,271.243,43.064,271.243,48.387z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M184.23,27.56c0,2.67-9.278,7.409-16.735,7.409s-9.507-1.248-9.507-3.917c0-2.67,6.035-7.551,13.492-7.551 C178.937,23.5,184.23,24.891,184.23,27.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M226.943,52.511c0,6.765-14.577,11.182-29.332,11.182c-14.756,0-26.89-7.823-26.89-14.589 c0-6.765,12.305-11.414,27.061-11.414C212.538,37.69,226.943,45.745,226.943,52.511z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M156.899,47.078c0,5.199-17.278,18.431-28.5,20.348c-11.704,1.999-15.437,0.11-15.437-5.089 c0-5.199,21.181-19.749,32.564-19.749C156.91,42.587,156.899,44.864,156.899,47.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M104.374,87.613c0,4.871-9.203,24.466-19.976,24.466c-10.775,0-9.303-7.341-9.303-12.213 c0-4.871,10.293-25.397,21.068-25.397C106.936,74.469,104.374,82.74,104.374,87.613z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M108.699,54.066c0,2.06-4.975,5.455-9.625,9.187c-7.693,6.171-10.51,1.145-10.51-0.917 c0-3.902,4.091-4.771,9.412-7.464C104.303,51.671,108.699,52.005,108.699,54.066z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M211.747,99.866c0.729,17.259-14.645,56.11-68.533,57.402c-34.51,0.827-45.112-26.139-45.112-43.412 c0-17.273,25.04-50.141,62.158-50.141C184.684,63.715,210.673,74.469,211.747,99.866z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1319",
    transform: "matrix(1.7309842912964262,0,0,1.7309842912964262,-2.973831725590813,118.28992553988928)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M243.267,48.17c-24.132,0-41.962-16.41-41.962-42.189c0-25.779,17.829-42.13,41.962-42.13 c18.283,0,32.932,9.369,38.781,24.927L266.15-5.431c-3.634-9.539-12.321-15.047-22.882-15.047 c-14.138,0-24.984,9.879-24.984,26.459c0,16.58,10.845,26.516,24.984,26.516c10.561,0,19.248-5.564,22.882-15.103l15.898,5.792 C276.2,38.744,261.551,48.17,243.267,48.17L243.267,48.17z M357.583-20.022h-30.436v18.624h26.971v14.82h-26.971v18.567h30.436 v15.046h-47.582v-82.048h47.582V-20.022L357.583-20.022z M445.151-35.014h16.977v82.048h-19.702L406.086-11.62v58.654h-16.977 v-82.048h19.475l36.565,58.315v-58.315H445.151z M544.928-35.014v14.99h-19.476v67.056h-16.863v-67.056h-19.59v-14.99h55.928 H544.928z M615.122,47.034l-21.349-36.112h-4.94v36.112h-17.034v-82.048h29.752c18.567,0,26.403,10.959,26.403,24.529 c0,11.015-6.246,18.17-17.375,20.555l24.699,36.964h-20.156H615.122z M588.832-20.874v19.589h10.05 c9.085,0,12.775-3.861,12.775-9.766c0-5.848-3.69-9.823-12.775-9.823H588.832z M661.751,47.034v-82.048h17.034v82.048H661.751z  M704.975,47.034l31.967-42.813l-31.06-39.235h20.725L747.049-8.1l20.441-26.914h20.725L757.154,4.221l31.967,42.813h-21.69 l-20.383-29.015l-20.384,29.015h-21.69H704.975z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentrixLongWhite);
export default __webpack_public_path__ + "static/media/centrix-long-white.38c068ae8e68c1689d51a89329995824.svg";
export { ForwardRef as ReactComponent };